<div class="login-page-wrapper">

  @if (!showPasswordResetForm) {
    <tm-login-form (loggedIn)="loggedIn($event)"
                   (requestPasswordReset)="onRequestPasswordReset()"
                   [insufficientRightsErrorMessage]="insufficientRightsMessage"
                   [login$]="login$"
                   [loginConfiguration]="loginConfiguration$ | async"
                   [redirectUrl]="routeBeforeLogin"
                   role="main"
                   i18n-loginErrorMessage="@@core.login.error"
                   loginErrorMessage="Login failed, please try again"></tm-login-form>
  }

  @if (showPasswordResetForm) {
    <tm-password-reset-request-form [requestReset$]="requestPasswordReset$" (backToLogin)="onBackToLogin()"></tm-password-reset-request-form>
  }
</div>
